import ApiService from '@/utils/ApiService'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    userDataOptions: [],
    itemOptions: [],
    customFieldTypeOptions: [
      {
        text: ('views.externalform.form.customFieldTypeOptions.input'),
        value: 1
      },
      {
        text: ('views.externalform.form.customFieldTypeOptions.label'),
        value: 2
      },
      {
        text: ('views.externalform.form.customFieldTypeOptions.date'),
        value: 3
      },
      {
        text: ('views.externalform.form.customFieldTypeOptions.select'),
        value: 4
      }
    ]
  },
  getters: {
    customFieldTypeOptions (state) {
      return state.customFieldTypeOptions.map(entry => {
        return {
          text: Vue.prototype.$lang.t(entry.text),
          value: entry.value
        }
      })
    },
    getCustomFieldTypeText: state => id => {
      return Vue.prototype.$lang.t(state.customFieldTypeOptions.find(entry => entry.value === id).text)
    },
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_a_b_custom_fields') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    }
  }
}
